import { apiClient } from '@/lib/api/client';
import type {
  MediaUploadResult,
  MerchantMediaListParams,
  MerchantMediaListResponse,
} from './types';

export async function listMediaAssets(
  params: MerchantMediaListParams,
): Promise<MerchantMediaListResponse> {
  const { data } = await apiClient.get<MerchantMediaListResponse>('/merchant/media', { params });
  return data;
}

/**
 * Upload a photo into the merchant's library (multipart, field `file`).
 * 201 is a new asset; 200 means the bytes deduped onto an existing one, which
 * is surfaced as `deduped` so the UI can say so instead of "added".
 * Server rejects with 415 (content type) or 413 (too large).
 */
export async function uploadMediaAsset(file: File): Promise<MediaUploadResult> {
  const formData = new FormData();
  formData.append('file', file);
  const { data, status } = await apiClient.post<MediaUploadResult['asset']>(
    '/merchant/media',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return { asset: data, deduped: status === 200 };
}

/** Soft delete — the asset drops out of the library; bytes stay on disk. */
export async function deleteMediaAsset(assetId: string): Promise<void> {
  await apiClient.delete(`/merchant/media/${assetId}`);
}
